var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDownLight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.5549 26.9748L37.9373 54.5549C37.4662 55.0259 36.9076 55.2615 36.2614 55.2615C35.6153 55.2615 35.0567 55.0259 34.5856 54.5549L6.96804 26.9748C6.49698 26.5037 6.26144 25.9389 6.26144 25.2802C6.26144 24.6216 6.49698 24.0567 6.96804 23.5856L13.146 17.4451C13.6171 16.9741 14.1757 16.7386 14.8219 16.7386C15.468 16.7386 16.0266 16.9741 16.4977 17.4451L36.2614 37.2089L56.0252 17.4451C56.4963 16.9741 57.0549 16.7386 57.701 16.7386C58.3472 16.7386 58.9058 16.9741 59.3768 17.4451L65.5549 23.5856C66.0259 24.0567 66.2614 24.6216 66.2614 25.2802C66.2614 25.9389 66.0259 26.5037 65.5549 26.9748Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDownLight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-down-light.5318d1cb54d36cdd62c0a068e1feeffd.svg";